"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ExplanationComponent = function () { return (React.createElement(React.Fragment, null,
    React.createElement("p", null,
        React.createElement("strong", null, "Background")),
    React.createElement("p", null, "This point system is created by SMU Gravical 2019 for their team event. A team consists of 2 climbers and they have 19mins to tackle the routes."),
    React.createElement("p", null, "The team event is unique as the climbers will be taking on buddy routes where both climbers are on the wall at the same time. They have to find creative solutions and help each other to reach the top of the route."),
    React.createElement("p", null,
        React.createElement("strong", null, "Explanation")),
    React.createElement("p", null, "Points will be awarded to each pair of climbers when they reach the \"Top\" hold of the climb together."),
    React.createElement("ul", null,
        React.createElement("li", null, "More points are awarded for fewer attempts taken."),
        React.createElement("li", null, "A multiplier is applied to the final score for pairs with female climbers.")),
    React.createElement("table", { style: { minWidth: '300px', margin: '10px auto', borderSpacing: '20px', textAlign: 'center' } },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null, "Attempts to Top"),
                React.createElement("th", null, "Points Awarded"))),
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", null, "1"),
                React.createElement("td", null, "100")),
            React.createElement("tr", null,
                React.createElement("td", null, "2"),
                React.createElement("td", null, "80")),
            React.createElement("tr", null,
                React.createElement("td", null, "3"),
                React.createElement("td", null, "60")),
            React.createElement("tr", null,
                React.createElement("td", null, "4"),
                React.createElement("td", null, "40")),
            React.createElement("tr", null,
                React.createElement("td", null, "5 or more"),
                React.createElement("td", null, "20")))),
    React.createElement("table", { style: { minWidth: '300px', margin: '10px auto', borderSpacing: '20px', textAlign: 'center' } },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null, "Number of females"),
                React.createElement("th", null, "Points multiplier"))),
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", null, "0"),
                React.createElement("td", null, "1x")),
            React.createElement("tr", null,
                React.createElement("td", null, "1"),
                React.createElement("td", null, "1.5x")),
            React.createElement("tr", null,
                React.createElement("td", null, "2"),
                React.createElement("td", null, "2x")))),
    React.createElement("p", null, "The aim is to get the most points! In the event of a tie, the winner will be determined by the total time taken to complete the routes."))); };
exports.default = ExplanationComponent;
//# sourceMappingURL=ExplanationComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/PointsGravical2019/ExplanationComponent.js
// module id = 734
// module chunks = 0